<div class="pdf-page app-aul-026-24" id="aul02624">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> RADIOACTIVE CONTAMINATION EXCLUSION </b>
  </p>

  <p class="font-medium">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <br />

  <div class="font-small">
    <ol>
      <li style="padding-bottom: 10px;">
        Notwithstanding any provision to the contrary within this Policy or any
        endorsement thereto, this Policy excludes any loss, liability, cost or
        expense, or any other amount incurred by or accruing to You, directly or
        indirectly and regardless of any other cause contributing concurrently
        or in any sequence, originating from, caused by, arising out of,
        contributed to by, resulting from, or otherwise in connection with:
        <ul style="list-style-type: none">
          <li style="padding-bottom: 10px; padding-top: 5px;">1.1.  irradiation or contamination by Nuclear Material; or</li>
          <li style="padding-bottom: 10px;">
            1.2.  the radioactive, toxic, explosive or other hazardous or
            contaminating properties of any radioactive matter; or
          </li>
          <li style="padding-bottom: 10px;">
            1.3.  any device or weapon employing atomic or nuclear fission and / or
            fusion or other like reaction or radioactive force or matter
          </li>
        </ul>
      </li>
    </ol>
  </div>
  <br />
  <p class="font-small"><b>Definitions </b></p>
  <div class="font-small">
    <ol start="2">
      <li style="padding-bottom: 10px;">
        Nuclear Material means:
        <ul style="list-style-type: none">
          <li style="padding-bottom: 10px; padding-top: 5px;">2.1.   Nuclear Fuel; or</li>
          <li style="padding-bottom: 10px;">
            2.2.  where the United States Atomic Energy Act of 1954 as amended
            applies:
            <ul style="list-style-type: none">
              <li style="padding-bottom: 10px; padding-top: 5px;">2.2.1. special nuclear material; or</li>
              <li style="padding-bottom: 10px;">2.2.2. source material; or</li>
              <li style="padding-bottom: 10px;">2.2.3. by-product material;</li>
            </ul>
            as defined in the Atomic Energy Act of 1954 as amended; or
          </li>
          <li style="padding-bottom: 10px;">
            2.3. where the Canadian Nuclear Liability Act R.S.C., 1985, c. N-28 or
            any law amendatory thereof applies:
            <ul style="list-style-type: none">
              <li style="padding-bottom: 10px; padding-top: 5px;">
                2.3.1. any material, other than thorium or natural or depleted uranium
                uncontaminated by significant quantities of fission products,
                that is capable of releasing energy by a self-sustaining chain
                process of nuclear fission;
              </li>
              <li style="padding-bottom: 10px;">
                2.3.2. radioactive material produced in the production or utilization
                of material referred to in paragraph 2.3.1; and
              </li>
              <li style="padding-bottom: 10px;">
                2.3.3. material made radioactive by exposure to radiation consequential
                on or incidental to the production or utilization of material
                referred to in paragraph 2.3.1; or
              </li>
            </ul>
          </li>
          <li style="padding-bottom: 10px;">
            2.4. in respect of any territory where the United States Atomic Energy
            Act of 1954 as amended and the Canadian Nuclear Liability Act
            R.S.C., 1985, c. N-28 or any law amendatory thereof do not apply,
            any other radioactive material (including but not limited to
            radioactive products and waste).
          </li>
        </ul>
      </li>
      <li style="padding-bottom: 10px;">
        Nuclear Fuel means any material, other than natural uranium or depleted
        uranium, capable of releasing nuclear energy by nuclear fission or
        otherwise, either alone or in conjunction with any other material.
      </li>
    </ol>
  </div>
</div>
